import React from "react";
import colors from "../../constants/colors";

interface FormSectionProps {
	// section title
	title: string;
	// render function to call with fetched data
	children: JSX.Element | JSX.Element[];
	// additional actions to include in the header
	headerActions?: JSX.Element | JSX.Element[];
}

const styles = {
	container: {
		display: "flex",
		flexWrap: "wrap" as any,
		maxWidth: 1004,
		width: "100%",
		marginBottom: 24,
		padding: "16px 24px",
		boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
		position: "relative" as any,
		borderLeft: `6px solid ${colors.blue700}`,
	},
	containerTitleWrapper: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
		marginTop: 6,
		minHeight: 50,
	},
	containerTitle: {
		fontSize: 16,
		letterSpacing: "0.01em",
		marginTop: 8,
		color: colors.gray700,
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
	},
};

/**
 * Renders an elevated form section
 */
export const FormSection = ({
	title,
	children,
	headerActions,
	...rest
}: FormSectionProps & React.HTMLProps<HTMLDivElement>) => (
	<div style={styles.container} {...rest}>
		<div style={styles.containerTitleWrapper}>
			<div>
				<h2 style={styles.containerTitle}>{title}</h2>
			</div>
			<div>{headerActions}</div>
		</div>

		{children}
	</div>
);
